let ctx = null;

const getCtx = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

// [frequency, start offset s, duration s]
const PATTERNS = {
  success: [[2400, 0, 0.09], [3000, 0.09, 0.09]],
  error: [[300, 0, 0.35]],
  duplicate: [[220, 0, 0.14], [220, 0.2, 0.14], [220, 0.4, 0.14], [220, 0.6, 0.2]],
};

// Loud square-wave beeps on one shared audio context, scheduled on the audio clock for zero lag
export const playScanSound = (type) => {
  try {
    const c = getCtx();
    const out = c.createDynamicsCompressor();
    out.connect(c.destination);
    const t0 = c.currentTime + 0.005;
    (PATTERNS[type] || PATTERNS.success).forEach(([freq, start, dur]) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = "square";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(1, t0 + start);
      gain.gain.setValueAtTime(0, t0 + start + dur);
      osc.connect(gain).connect(out);
      osc.start(t0 + start);
      osc.stop(t0 + start + dur + 0.01);
    });
  } catch {
    // audio not available
  }
};

export const unlockScanSound = () => {
  try { getCtx(); } catch { /* ignore */ }
};
